<template>
    <div class="examList">
        <div class="testListBox"  v-loading="loading">
            <div
             class="testList col col-sm-6 col-md-4"
             v-for="(item, index) in testList"
             :key="index">
                <div>
                    <div class="testInfoBox">
                        <span>{{ item.testName }}</span>
                        <span>{{ item.test && item.test.referenceTimeType? item.test.referenceTimeType : '' }}</span>
                        <span v-if="item.status == '已开考' || item.test && item.test.referenceTimeType && item.test.referenceTimeType == '固定时间考试'">{{ `${item.testDateYTD} 开考` }}</span>
                        <span v-if="item.status == '待考' && item.test">{{ `${item.test.startDate}开考 ${item.test.endDate}结束` }}</span>
                        <span v-if="item.status == '已开考'">
                            <span>{{ item.startTime }} 开始</span>
                            <span>{{ item.endTime }} 结束</span>
                        </span>
                        <span v-if="type == '已完成'">得分：{{ item.totalScore? item.totalScore : 0 }}</span>
                    </div>
                    <div class="ItemFooter">
                        <el-button v-if="type == '待考'" @click="getCurrentDate(item)" type="primary" round>前往考试</el-button>
                        <el-button v-if="type == '已完成'" type="primary" round @click="$router.push({ name: 'testPaper', query: {id: item.id} })">查看试卷</el-button>
                        <!-- <el-button type="primary" round>前往考试</el-button> -->
                    </div>
                </div>
            </div>
            <span v-if="testList.length == 0" class="default">
                <img src="@/assets/icon/notdata.png" alt="">
                暂时没有考试
            </span>
        </div>
    </div>
</template>
<script>
import testApi from '@/request/api/test';
import testPaperApi from '@/request/api/testPaper';
import { judgmentTime } from '@/utils';

export default {
    props: {
        type: String
    },
    data() {
        return {
            testList: [],
            loading: true,
            current: "",
            hostName: location.hostname,
        }
    },
    created() {
        $(document).scrollTop(0);
        this.getTestList();
    },
    methods: {
        //获取考试列表
        getTestList() {
            let params = {
                "endDate": "",
                "name": "",
                "pageNumber": 1,
                "pageSize": 999,
                "sortDirection": 0,
                "sortName": "testDateYTD",
                "startDate": "",
                "isPass": "",
                "status": this.type
            };
            testApi.myTestPaperList(params, res => {
                if(res.succeed) {
                    this.testList = res.data.content;
                }
                this.loading = false;
                this.$emit('changeLoading')
            })
        },
        getCurrentDate(item) {
            // let msg = {
            //     startContent: "开考时间前30分钟以内才可进入",
            //     endContent: "考试已经结束"
            // };
            // judgmentTime(item.testDateYTD, item.startTime, item.endTime, msg, () => {
            // window.location.href = `https://${this.hostName}/psp/examCenter/ExamOnline?id=${item.id}`;
            this.$router.push(`/readyExam?testId=${item.testId}&id=${item.id}`)
            // }, item)
        },
    },
}
</script>
<style scoped lang="scss">
.testListBox {
    min-height: 450px;
}
.testList {
    // display: flex;
    // flex-direction: row;
    // justify-content: space-between;
    // align-items: center;
    /* width: 100%; */
    /* height: 50px; */
    
    padding: 0 20px;
    margin-bottom: 30px;
    
    >div{
        border-radius: 5px;
        color: #000;
        background: #fff;
        padding: 10px;
        border-radius: 5px;
        box-shadow: 0 10px 5px rgba(0, 0, 0, .2);
        &:hover {
            background: #B0E0E6;
        }
    }
}
.testInfoBox {
    >span {
        display: block;
    }
   
    /* display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center; */
}
.ItemFooter{
    text-align: center;
    padding: 8px 0;
}
.default  {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 100px;
    color: #8a8a8a;
    font-size: 15px;
}
.default  img {
    width: 80px;
}
</style>


// WEBPACK FOOTER //
// src/components/examList.vue